/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import NetworkNode = Models.NetworkNode;
    interface ITsProbeRouteParams extends ng.route.IRouteParamsService {
        id: number;
        portId: number;
    }


    /**
     * TsProbeController class
     */
    export class TsProbeController {
        public static $name: string = "tsProbeController";
        public static $inject: string[] = [
            'tsProbeService',
            'networkService',
            'networkNodeTypeService',
            'networkNodeService',
            '$sce',
            '$routeParams',
            'navigationHistoryService',
            '$window',
            'ModalService',
            'aclService',
            '$rootScope',
        ];

        public probeNetworkNodes: NetworkNode[];
        public showIframe: string = "";
        public currentNode: NetworkNode;
        public networks: Models.INetwork[];
        public showBackButton: boolean = false;

        /**
         * Constructor of the class.
         */
        constructor(private tsProbeService: Application.Services.TsProbeService,
                    private networkService: Application.Services.NetworkService,
                    private networkNodeTypeService: Services.NetworkNodeTypeService,
                    private networkNodeService: Services.NetworkNodeService,
                    private $sce: ng.ISCEService,
                    private $routeParams: ITsProbeRouteParams,
                    private navigationHistoryService: Services.NavigationHistoryService,
                    private $window: ng.IWindowService,
                    private modalService: ngModal.IModalService,
                    private aclService: Services.AclService,
                    private $rootScope: Services.IFlexSettings) {

            this.initData();
            this.initBackButton();
        }


        public getProbesNetworkNodes(): ng.IPromise<NetworkNode[]> {
            return this.networkNodeTypeService.findByName("TNS4200").then((type: Models.INetworkNodeType) => {
                return this.networkNodeService.getAllByNetworkNodeTypeId(type.id);
            });
        }

        public showProbeInterface(node: NetworkNode): void {
            this.tsProbeService.getProbeGuiByProbeId(Common.Utils.idFromHref(node.href)).then(( probeGui: Models.IDeviceGui ) => {
                try {
                    if ( this.$rootScope.backendConfig.flexoProxyType === 'PORT_BASED' && probeGui.proxyType !== "HOST_DISABLED") {
                        this.showIframe = this.$sce.trustAsResourceUrl(probeGui.guiUrl);
                    }
                    this.currentNode = node;
                } catch (e) {
                    console.log(e);
                    this.showDeviceUnreachableModal();
                }
            }).catch(() => {
                this.showDeviceUnreachableModal();
            });
        }

        public showProbeAlarmInterfaceByNodeId(nodeId: number, portId: number): void {
            this.tsProbeService.getProbeGuiByProbeId(nodeId).then(( probeGui: Models.ITsProbeGui ) => {
                this.tsProbeService.getTSProbeGuiSectionUrl(nodeId, 'alarms', portId).then( (uri: string) => {
                    try {
                        this.showIframe = this.$sce.trustAsResourceUrl(probeGui.guiUrl +  uri);
                        this.networkNodeService.getByIdPromise( nodeId ).then( (node: NetworkNode) => {
                            this.currentNode = node;
                        });

                    } catch (e) {
                        console.log(e);
                    }
                });
            });
        }

        public showDeviceUnreachableModal(): void {
            this.modalService.showModal({
                templateUrl: Controllers.ErrorModalController.templateURL,
                controller: Controllers.ErrorModalController.$name,
                inputs: {
                    title: 'Device unreachable',
                    description: `The selected device is unreachable. Please verify that the device is running and there are no
                                      network problems.`,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Controllers.ErrorModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result: Object) => {
                    modalElem.hide();
                });
            });
        }

        public initBackButton(): void {
            let previousRoute: string = this.navigationHistoryService.getPreviousLocation();
            if (previousRoute && (previousRoute.indexOf("/stream") !== -1 || previousRoute.indexOf("/matrix-room") !== -1)) {
                this.showBackButton = true;
            } else {
                this.showBackButton = false;
            }
        }

        /**
         * Initiliaze data
         */
        private initData(): void {

            this.getProbesNetworkNodes().then((networkNodes: NetworkNode[]) => {
                this.probeNetworkNodes = networkNodes.sort((n1: NetworkNode, n2: NetworkNode) => n1.name.localeCompare(n2.name));
                this.probeNetworkNodes.forEach((node: NetworkNode) => {
                    this.tsProbeService.getProbeGuiByProbeId(Common.Utils.idFromHref(node.href)).then((probeGui: Models.IDeviceGui) => {
                        node.gui = probeGui;
                    }).catch(() => {
                        // empty block
                    });
                });

            }).finally(() => {
                if (!this.probeNetworkNodes) {
                    this.probeNetworkNodes = [];
                }

            });
            if (this.$routeParams.id) {
                this.showProbeAlarmInterfaceByNodeId(this.$routeParams.id, this.$routeParams.portId ? this.$routeParams.portId : 0);
            }

        }

    }
}
